import {Breadcrumb} from 'antd';
import Link from 'next/link';
import PropTypes from 'prop-types';

export default function BreadcrumbNav({items}) {
    return (
        <div className="breadcrumb-full">
            <div className="breadcrumb-inner">
                <Breadcrumb separator=">">
                    {items.map((item, index) => {
                        const isUppercase = item.uppercase !== false;
                        const labelText = item.label ? (isUppercase ? item.label.toUpperCase() : item.label) : '';

                        return (
                            <Breadcrumb.Item key={index}>
                                {item.href ? (
                                    <Link href={item.href}>
                                        <span
                                            style={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                cursor: 'pointer',
                                                color: item.color || '#2d2d2d',
                                                fontSize: '16px',
                                            }}>
                                            {item.icon && <span style={{marginRight: 4}}>{item.icon}</span>}
                                            {labelText}
                                        </span>
                                    </Link>
                                ) : (
                                    <span
                                        style={{
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            color: item.color || '#2d2d2d',
                                            fontSize: '16px',
                                        }}>
                                        {item.icon && <span style={{marginRight: 4}}>{item.icon}</span>}
                                        {labelText}
                                    </span>
                                )}
                            </Breadcrumb.Item>
                        );
                    })}
                </Breadcrumb>
            </div>
        </div>
    );
}

BreadcrumbNav.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
            href: PropTypes.string,
            icon: PropTypes.node,
            color: PropTypes.string,
            uppercase: PropTypes.bool,
        }),
    ).isRequired,
};
